export const FILTRO_SET = 'FILTRO_SET'; 